// extracted by mini-css-extract-plugin
module.exports = {"container":"RoundedChip_container__i_HB8","dark":"RoundedChip_dark__3Rnrp"};